import React, {useEffect, useState} from "react";
import Box from "../../lib/appfuse-react/component/Box";
import Paper from "../../lib/appfuse-react/component/Paper";
import {Divider, Grid, Typography} from "@material-ui/core";
import Form from "../../lib/appfuse-react/component/Form";
import CircularProgress from "../../lib/appfuse-react/component/CircularProgress";
import organizationService from "../../service/organization/organizationService";
import {useSelector} from "../../store";
import {isAuthenticated} from "../../reducer/iam/authReducer";
import {withDesktop} from "../../layout/Desktop";
import {withExplorer} from "../../layout/Explorer";
import i18n from "../../lib/appfuse-react/core/i18n";
import DataTable, {DataColumn} from "../../lib/appfuse-react/component/DataTable";
import useResponsive from "../../lib/appfuse-react/hook/useResponsive";

function ContactUsContent() {
    const [value, setValue] = useState({});
    const [ready, setReady] = useState(false);

    useEffect(() => {
        (async () => {
            const data = await organizationService.get();
            setValue(data);
            setReady(true);
        })();
    }, []);

    const responsive = useResponsive();
    const isMobile = !responsive.isLargeScreen();
    const CombinedContact = isMobile? MobileContact: Contact;

    return (
        <Box fullHeight fullWidth overflow='hidden'>
            <Paper fullWidth fullHeight square overflow='hidden' variant='outlined'>
                <CircularProgress value={ready} fullWidth fullHeight backgroundColor='white'>
                    <Box fullHeight fullWidth padding={4} overflow='auto'>
                        <Form value={value}>
                            <Grid container spacing={2}>
                                <CombinedContact name='taipeiContactInfo' title='Taipei Headquarters Office'/>
                                <CombinedContact name='hsinchuContactInfo' title='Hsinchu branch office'/>
                            </Grid>
                        </Form>
                    </Box>
                </CircularProgress>
            </Paper>
        </Box>
    );
}

function Contact(props) {
    const {value={}, title} = props;
    const {persons=[]} = value;

    return (
        <Grid item xs={12} md={6}>
            <Box margin={4}>
                <Box paddingY={2}>
                    <Typography variant='h6'>{i18n.translate(title)}</Typography>
                </Box>
                <Box display='flex' marginBottom={2} marginLeft={2} gap={0.5}>
                    <Typography>{i18n.translate('Phone') + " : "}</Typography>
                    <Typography>{value.phone || ''}</Typography>
                </Box>
                <DataTable data={persons || []}>
                    <DataColumn accessor='name' label='Contact Person'/>
                    <DataColumn accessor='jobTitle' label='Job Title'/>
                    <DataColumn accessor='extension' label='Extension'/>
                    <DataColumn accessor='email' label='Email'/>
                </DataTable>
            </Box>
        </Grid>
    );
}

function MobileContact(props) {
    const {value={}, title} = props;
    const {persons=[]} = value;

    const contactInfos = persons.map((person, index) => {
        return <MobileContactInfo key={index} {...person} />;
    });

    return (
        <Box margin={4}>
            <Box paddingY={2}>
                <Typography variant='h6'>{i18n.translate(title)}</Typography>
            </Box>
            <Box display='flex' marginBottom={2} gap={0.5}>
                <Typography>{i18n.translate('Phone') + " : "}</Typography>
                <Typography>{value.phone || ''}</Typography>
            </Box>
            {contactInfos}
        </Box>
    );
}

function MobileContactInfo(props) {
    const {name, jobTitle, extension, email} = props;

    return (
        <React.Fragment>
            <Box display={'flex'} flexDirection={'column'} marginBottom={1} marginTop={1} fullWidth>
                <Box display={'flex'} gap={1}>
                    <Typography>{name}</Typography>
                    <Typography>{jobTitle}</Typography>
                </Box>
                <Typography>{`分機：${extension}`}</Typography>
                <Typography>{`電子信箱：${email}`}</Typography>
                <Divider/>
            </Box>
        </React.Fragment>
    );
}

function ContactUs() {
    const authenticated = useSelector(isAuthenticated);

    return authenticated? withDesktop(ContactUsContent)():withExplorer(ContactUsContent)();
}

export default ContactUs;